import { day } from 'libs/day';

export enum GroupType {
  BY_MONTH = 'month',
  BY_DAY = 'date',
  BY_WEEK = 'week',
  BY_HOUR = 'hour',
}

export const getGroupRangeByDate = (startDate: day.Dayjs, endDate: day.Dayjs): GroupType => {
  if (!startDate || !endDate) {
    return GroupType.BY_DAY;
  }
  const days = endDate.diff(startDate, 'days');
  if (days < 1) {
    return GroupType.BY_HOUR;
  }
  if (days > 31 && days <= 182) {
    return GroupType.BY_WEEK;
  }
  if (days <= 31) {
    return GroupType.BY_DAY;
  }
  return GroupType.BY_MONTH;
};

export const formatMinutesIntoHours = (totalMinutes: number) => {
  if (!totalMinutes) return '00:00:00';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const seconds = 0;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
};

export const formatDateFull = (date: Date) => {
  if (!date) return 'N/A';
  return day(date).format('MMM D, YYYY HH:mm');
};
